import { Action, FrameStencils, Marker, Point, StencilType } from "../../types";
import { getDistanceBetweenPoints } from "../get-distance-between-points";

export const ACTION_RANGE = 3;

/** ================================
 * Get Closest Stencil To Point
 * given a point and list of stencils, get the stencil closest to the point within the ACTION_RANGE.
 * if the stencil in stencils is an Action, you can optionally check against the action's endPos
 ================================ */
interface GetClosestStencilToPointProps {
  point: Point;
  stencils: FrameStencils;
  // if stencil checking against is an action, check against its endPos instead of startPos
  actionPos?: "pos" | "endPos";
  customActionRange?: (stencil: Action | Marker) => number;
}
export const getClosestStencilToPoint = <T = Action | Marker>({
  point,
  stencils,
  actionPos = "pos",
  customActionRange = () => ACTION_RANGE,
}: GetClosestStencilToPointProps): T | null => {
  const stencilDistancesSorted = [
    // for stencils..
    ...stencils
      .map((stencil) => {
        // interpret stencil position based on type
        const { stencilType } = stencil;
        const stencilPos = stencilType === StencilType.MARKER ? stencil.pos : stencil[actionPos];
        // return stencil with its distance from target point
        return {
          stencil,
          distance: getDistanceBetweenPoints({ x1: stencilPos.x, y1: stencilPos.y, x2: point.x, y2: point.y }),
        };
      })
      // filter out all stencils outside ActionRange
      .filter(({ distance, stencil }) => distance <= customActionRange(stencil)),
  ]
    //sort by distance ASC
    .sort((a, b) => a.distance - b.distance);

  // if there are any stencils within the action range, return the first closeset
  if (stencilDistancesSorted.length > 0) return stencilDistancesSorted[0]?.stencil as T;
  // else return null if none within range
  else return null;
};
